import { defineMessages } from 'react-intl';

export default defineMessages({
  checking: {
    id: 'ResendEmailLoader.checking',
    defaultMessage: 'Checking if order is eligible for a confirmation email resend...',
  },
});
